module.exports = __webpack_public_path__ + "static/media/admin-login-logo.00159b05.png";